/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineMenu, HiOutlinePencil } from "react-icons/hi";

import ListPage from "../../layout/ListPage";
import type { Action, Column } from "../../ui";
import { useStaticContext } from "../../context/StaticContext";
import { pushOneFooter } from "../../lib/sysNavigation/SysNavigation";

type FooterRow = {
  footer_id: number | string;
  title?: string;
  description?: string;
  [key: string]: unknown;
};

const editRoute = "/footer/edit";

const Overview: React.FC = () => {
  const navigate = useNavigate();
  const { footer, fetchFooter } = useStaticContext() as any;

  useEffect(() => {
    if (!footer) fetchFooter();
  }, [footer]);

  const rows = useMemo<FooterRow[] | null>(() => {
    if (!Array.isArray(footer)) return null;
    return footer as FooterRow[];
  }, [footer]);

  const columns: Column<FooterRow>[] = [
    {
      header: "Title",
      cell: (row) => (
        <span className="font-medium text-gray-900">{row.title ?? "—"}</span>
      ),
    },
    {
      header: "Description",
      cell: (row) => (
        <span className="line-clamp-2 text-gray-600">{row.description ?? "—"}</span>
      ),
    },
  ];

  const rowActions = (row: FooterRow): Action[] => [
    {
      label: "Edit",
      icon: <HiOutlinePencil className="h-3.5 w-3.5" />,
      onClick: () => {
        pushOneFooter(row);
        navigate(editRoute);
      },
    },
  ];

  return (
    <ListPage<FooterRow>
      title="Footer"
      subtitle="Sections shown in the public site footer."
      icon={<HiOutlineMenu className="h-5 w-5" />}
      rows={rows}
      columns={columns}
      rowKey={(r) => r.footer_id}
      rowActions={rowActions}
      empty="No footer sections yet."
    />
  );
};

export default Overview;
